import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { extractHubspotFormParameters } from 'ha/utils/thirdParty/extractHubspotFormParameters';
import { HubspotFormContainer as HubspotForm } from 'ha/modules/HubspotForm';
import { InstagramCard } from 'ha/components.legacy/InstagramCard';
import { YoutubeCard } from 'ha/components.legacy/YoutubeCard';
import { Plot } from 'ha/components.legacy/Plot';
import { Tablau } from 'ha/components.legacy/Tablau';
import { isYoutubeVideo } from 'ha/utils/thirdParty/youtubeUrl';
import { isInstagramPost } from 'ha/utils/thirdParty/isInstagramPost';
import {
  isPlotlyUrl,
  isTableaUrl,
  isInfogramUrl,
} from 'ha/utils/thirdParty/plots';
import { Markdown } from './Markdown';
import { MarkdownH1 } from './MarkdownH1';
import { MarkdownH2 } from './MarkdownH2';
import { MarkdownH3 } from './MarkdownH3';
import { MarkdownP } from './MarkdownP';
import { MarkdownLink } from './MarkdownLink';
import { MarkdownImage } from './MarkdownImage';
import { MarkdownBlockquote } from './MarkdownBlockquote';

const remarkDefaultComponents = {
  h1: MarkdownH1,
  h2: MarkdownH2,
  h3: MarkdownH3,
  p: MarkdownP,
  a: ({ children, href, ...rest }) => {
    const text = Array.isArray(children) ? children[0] : children;

    if (!text || text === href) {
      if (isYoutubeVideo(href)) {
        return <YoutubeCard src={href} />;
      }
      if (isInstagramPost(href)) {
        return <InstagramCard src={href} />;
      }
      if (isTableaUrl(href)) {
        return <Tablau href={href} />;
      }
      if (isPlotlyUrl(href) || isInfogramUrl(href)) {
        return <Plot src={href} />;
      }
    }

    return (
      <MarkdownLink {...rest} href={href}>
        {children}
      </MarkdownLink>
    );
  },
  blockquote: MarkdownBlockquote,
  code: ({ children }) => {
    const code = Array.isArray(children) ? children[0] : children;

    if (typeof code === 'string') {
      const params = extractHubspotFormParameters(code);

      // if hubspot code for embedding the form is provided, render the form
      // instead of plain text, it's a hacky solution, but simplifies the flow
      // for content creators and marketing team, allowing to copy/paste embed code
      // directly, instead of creating custom markdown elements or allowing to run
      // scripts from markdown which can produce security issues
      if (params) {
        return (
          <HubspotForm portalId={params.portalId} formId={params.formId} />
        );
      }
    }

    return <code>{children}</code>;
  },
  img: MarkdownImage,
};

const MarkdownContent = ({ content, components, className = '' }) => (
  <Markdown
    className={cx('md__content', className)}
    content={content}
    components={{
      ...remarkDefaultComponents,
      ...components,
    }}
  />
);

MarkdownContent.propTypes = {
  content: PropTypes.string.isRequired,
  components: PropTypes.object,
  className: PropTypes.string,
};

MarkdownContent.defaultProps = {
  components: [],
  className: null,
};

export { MarkdownContent };
